import { Component, ElementRef, OnInit, inject, viewChild, signal } from "@angular/core";
import { BookingsService } from '../../services/bookings.service';
import { UntypedFormBuilder, Validators, UntypedFormGroup, UntypedFormArray, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { Blog } from '../../models/blog';
import { Category } from '../../models/category';
import { FormControl } from '@angular/forms';
import { CategoryService } from '../../services/categories.service';
import { ConfirmationService, MessageService, SelectItem, PrimeTemplate } from "primeng/api";
import * as moment from 'moment';
import { TYPE_LIST, STATUS_ROOMS, STATE_LIST } from '../../constants/constants';
import { Clients } from 'src/app/models/clients';
import { ClientsService } from 'src/app/services/clients.service';
import { Location } from '@angular/common';
import { WorksService } from 'src/app/services/works.service';
import { Works } from 'src/app/models/works';
import { EmployeesService } from 'src/app/services/employees.service';
import { Employees } from 'src/app/models/employees';
import { Locations } from 'src/app/models/locations';
import { LocationsService } from 'src/app/services/locations.service';
import { Bookings } from 'src/app/models/bookings';
import { SumPipe } from '../../pipe/sum.pipe';
import { TimesheetsService } from 'src/app/services/timesheets.service';
import { Rooms } from 'src/app/models/rooms';
import { SkillsService } from 'src/app/services/skills.service';
import { map, tap } from 'rxjs/operators';
import { Technical_data } from 'src/app/models/technical_data';
import { TechnicalDataService } from 'src/app/services/technical_data.service';
import { Projects } from 'src/app/models/projects';
import { Bind } from 'primeng/bind';
import { Card } from 'primeng/card';
import { ButtonDirective } from 'primeng/button';
import { Tabs, TabList, Tab, TabPanels, TabPanel } from 'primeng/tabs';
import { Ripple } from 'primeng/ripple';
import { InputText } from 'primeng/inputtext';
import { Select } from 'primeng/select';
import { MultiSelect } from 'primeng/multiselect';
import { SelectButton } from 'primeng/selectbutton';
import { Textarea } from 'primeng/textarea';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { Toast } from 'primeng/toast';

export interface fPairs {
  qty: number,
  price: number,
}

@Component({
    standalone: true,
    selector: "app-timesheets-form",
    templateUrl: "./timesheets-form.component.html",
    imports: [FormsModule, ReactiveFormsModule, Bind, Card, ButtonDirective, Tabs, TabList, Ripple, Tab, TabPanels, TabPanel, InputText, Select, MultiSelect, SelectButton, PrimeTemplate, Textarea, ConfirmDialog, Toast]
})
export class TimesheetsFormComponent implements OnInit {
  private fb = inject(UntypedFormBuilder);
  private bookingsService = inject(BookingsService);
  private technicalDataService = inject(TechnicalDataService);
  private messageService = inject(MessageService);
  private clientsService = inject(ClientsService);
  private _location = inject(Location);
  private timesheetsService = inject(TimesheetsService);
  private skillsService = inject(SkillsService);
  private employeesService = inject(EmployeesService);
  private worksService = inject(WorksService);
  private categoryService = inject(CategoryService);
  private confirmationService = inject(ConfirmationService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  readonly myInputVariable = viewChild<ElementRef>("myInput");

  readonly pageTitle = signal<string>(undefined);
  readonly error = signal<string>(undefined);
  readonly uploadError = signal<string>(undefined);
  readonly imagePath = signal<any>(undefined);
  blogs: Blog;
  blog: Blog;
  readonly id = signal<string>(undefined);
  bookings: Bookings;
  booking: any;

  readonly categories = signal<any>([]);
  category: Category;

  readonly works = signal<any>([]);
  work: Works;

  checked: boolean = true;
  selectedValue: string;
  rooms: any = [];
  room: Rooms;
  blogForm: UntypedFormGroup;
  readonly typeList = signal<any[]>(undefined);
  projects: any = [];
  readonly stateOptions = signal<any[]>(undefined);

  clients: any = [];
  client: Clients;
  arrString: string;

  readonly employees = signal<any>([]);
  employee: Employees;

  description: any;
  readonly selectedWorks = signal<SelectItem[]>([]);
  selectedSkills: SelectItem[] = [];
  selectedWorks2: SelectItem[];
  readonly selectedCategories = signal<SelectItem[]>([]);

  locations: any = [];
  location: Locations;

  cities: Blog[];
  format1: string = "";
  format2: string = "";
  selectedCity: Blog;
  selectedClients: SelectItem[];

  readonly selectedDate = signal<Date>(undefined);
  date: Date;
  works_id: any;
  category_id: any;
  public dataValues: object;
  pages: any;
  readonly currentUser = signal<any>(undefined);
  fPairs: any;
  addForm: UntypedFormGroup;
  rows: UntypedFormArray;
  itemForm: UntypedFormGroup;
  skillsForm: UntypedFormGroup;
  readonly skillsValues = signal<any>([]);

  trackByFn(index, item) {
    return item.id;
  }

  constructor() {
    if (this.date) {
      this.selectedDate.set(new Date(this.date));
    }
    this.typeList.set(TYPE_LIST);
    this.stateOptions.set(STATE_LIST);
    this.currentUser.set(JSON.parse(localStorage.getItem('currentUser') || '[]'));
  }

  ngOnInit() {
    const userId = this.currentUser().user_id;

    this.getselectedWorks;
    this.getselectedCategories;

    this.employeesService.getAllListbyUser().subscribe(
      (data: Employees) => (this.employees.set(data)),
      (error) => (this.error.set(error))
    );

    this.worksService.getAllListbyUser().subscribe(
      (data: Works) => (this.works.set(data)),
      (error) => (this.error.set(error))
    );

    this.categoryService.getAllListbyUser().subscribe(
      (data: Category) => (this.categories.set(data)),
      (error) => (this.error.set(error))
    );

    const id = this.route.snapshot.paramMap.get("id");

    this.timesheetsService.skills(id).subscribe(value => {
      this.skillsValues.set(value);
    });

    if (id) {
      this.pageTitle.set("Modifica Prodotto");

      this.timesheetsService.getId(id).subscribe((res) => {

        if (res.user_id == this.currentUser().user_id) {
        this.blogForm.patchValue({
          title: res.title,
          description: res.description.split(','),
          category_id: res.category_id.split(','),
          status: res.status,
          employee_id: res.employee_id,
          is_featured: res.is_featured,
          is_active: res.is_active,
          code: res.code,
          user_id: this.currentUser().user_id,
          description_full: res.description_full,
          code_int: res.code_int,
          price: res.price,
          price_extra: res.price_extra,
          id: res.id,
          data: res.data,
        });

      }
      else {
        this.router.navigate(['/admin/rooms']);
      }
        this.imagePath.set(res.image);
        this.id.set(res.id);
      });
    } else {
      this.pageTitle.set("Aggiungi Prodotto");
    }

    this.blogForm = this.fb.group({
      id: [""],
      title: ["", Validators.required],
      description: [""],
      description_full: [""],
      is_featured: ["0"],
      category_id: [""],
      status: [""],
      employee_id: [""],
      is_active: ["0"],
      image: [""],
      code: [""],
      user_id: [this.currentUser().user_id],
      code_int: [""],
      price: [""],
      price_extra: [""],

  });

  }

  getWorksItem(works_id: string, id: string) {
    return this.works().find(item => item.id === works_id);
  }

  getselectedWorks() {
  this.selectedWorks.set(this.works_id.split(','));
  }

  getCategoryItem(category_id: string, id: string) {
    return this.categories().find((item) => item.id === category_id);
  }

  getselectedCategories() {
    this.selectedCategories.set(this.category_id.split(','));
    }

  goback() {
    this._location.back();
  }

  onSelectedFile(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.blogForm.get("image").setValue(file);

      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (_event) => {
        this.imagePath.set(reader.result);
      };
    }
  }

  removeImageFile() {
    this.imagePath.set("");
    const myInputVariable = this.myInputVariable();
    console.log(myInputVariable.nativeElement.files);
    myInputVariable.nativeElement.value = "";
    console.log(myInputVariable.nativeElement.files);
  }

  get title() {
    return this.blogForm.get("title");
  }

  onSubmit() {
    const formData = new FormData();

    formData.append("title", this.blogForm.get("title").value);
    formData.append("description", this.blogForm.get("description").value);
    formData.append("description_full", this.blogForm.get("description_full").value);
    formData.append("is_featured", this.blogForm.get("is_featured").value);
    formData.append("category_id", this.blogForm.get("category_id").value);
    formData.append("employee_id", this.blogForm.get("employee_id").value);
    formData.append("is_active", this.blogForm.get("is_active").value);
    formData.append("image", this.blogForm.get("image").value);
    formData.append("code", this.blogForm.get("code").value);
    formData.append("code_int", this.blogForm.get("code_int").value);
    formData.append("price", this.blogForm.get("price").value);
    formData.append("price_extra", this.blogForm.get("price_extra").value);
    formData.append("status", this.blogForm.get("status").value);
    formData.append('user_id', this.blogForm.get('user_id').value);

    const id = this.blogForm.get("id").value;

    if (id) {
      this.timesheetsService.update(formData, id).subscribe(
        (res) => {
          if (res.status == "error") {
            this.uploadError.set(res.message);
          } else {
            this.messageService.add({ key: 'myKey1', severity: 'success', summary: 'Informazioni', detail: 'Salvato con sucesso' });

          }
        },
        (error) => (this.error.set(error))
      );
    } else {
      this.timesheetsService.create(formData).subscribe(
        (res) => {
          if (res.status === "error") {
            this.uploadError.set(res.message);
          } else {
            this.messageService.add({ key: 'myKey1', severity: 'success', summary: 'Informazioni', detail: 'Salvato con sucesso' });
            this.router.navigate(['/admin/rooms']);

          }
        },
        (error) => (this.error.set(error))
      );
    }
  }
}
